import { render, staticRenderFns } from "./ArticlesAdminHome.vue?vue&type=template&id=201ab2bc&scoped=true&"
import script from "./ArticlesAdminHome.vue?vue&type=script&lang=js&"
export * from "./ArticlesAdminHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201ab2bc",
  null
  
)

export default component.exports